import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content w-100" }
const _hoisted_2 = { class: "diary-info shadow-sm mt-3" }
const _hoisted_3 = { class: "name mb-2" }
const _hoisted_4 = { class: "info-date" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-hourglass-start mr-1" }),
  /*#__PURE__*/_createTextVNode("Ngày bắt đầu: ")
], -1)
const _hoisted_6 = { class: "info-date" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-hourglass-end mr-1" }),
  /*#__PURE__*/_createTextVNode("Ngày kết thúc: ")
], -1)
const _hoisted_8 = { class: "info-date" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-sort-numeric-up mr-1" }),
  /*#__PURE__*/_createTextVNode("Sản lượng: ")
], -1)
const _hoisted_10 = { class: "mt-2" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Đã đóng")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("OPENING")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "w-100 title mt-2 pl-3" }, "GIAI ĐOẠN CANH TÁC", -1)
const _hoisted_14 = {
  key: 0,
  class: "phases w-100 px-3"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "left" }
const _hoisted_17 = { class: "title" }
const _hoisted_18 = { class: "sub-title" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "sub-title" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Cập nhật lần cuối: ")
const _hoisted_22 = { class: "mt-2" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Chưa thực hiện")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Đang thực hiện")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Đã thực hiện")
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-chevron-right" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tag3 = _resolveComponent("Tag3")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.diaryItem?.name), 1),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(_ctx.diaryItem?.startAt
            ? _ctx.format(new Date(_ctx.diaryItem?.startAt), "dd/MM/yyyy")
            : "Chưa xác định"), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createTextVNode(" " + _toDisplayString(_ctx.diaryItem?.endAt
            ? _ctx.format(new Date(_ctx.diaryItem?.endAt), "dd/MM/yyyy")
            : "Chưa xác định"), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createTextVNode(" " + _toDisplayString(_ctx.diaryItem?.production) + " tấn ", 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.diaryItem?.status == 'CLOSED')
          ? (_openBlock(), _createBlock(_component_Tag3, {
              key: 0,
              effect: "dark",
              type: "info"
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.diaryItem?.status == 'OPENING')
          ? (_openBlock(), _createBlock(_component_Tag3, {
              key: 1,
              effect: "dark",
              type: "success"
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_13,
    (_ctx.diaryItem?.phases && _ctx.diaryItem?.phases.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.diaryItem?.phases, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (_ctx.checkVisiblePhases(item?.id))
                ? (_openBlock(), _createElementBlock("div", {
                    class: "diary-item shadow-sm",
                    onClick: ($event: any) => (_ctx.handleDetail(item?.id)),
                    key: item.id
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, _toDisplayString(item.name), 1),
                      _createElementVNode("div", _hoisted_18, [
                        _createTextVNode(" Bắt đầu: " + _toDisplayString(_ctx.diaryItem?.startAt
                  ? _ctx.format(new Date(_ctx.diaryItem?.startAt), "dd/MM/yyyy")
                  : "Chưa xác định") + " ", 1),
                        (_ctx.diaryItem?.endAt)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, "đến: " + _toDisplayString(_ctx.diaryItem?.endAt
                    ? _ctx.format(new Date(_ctx.diaryItem?.endAt), "dd/MM/yyyy")
                    : "Chưa xác định"), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _createElementVNode("span", null, _toDisplayString(_ctx.format(new Date(_ctx.diaryItem?.updatedAt), "dd/MM/yyyy")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        (item?.status == 'PENDING')
                          ? (_openBlock(), _createBlock(_component_Tag3, {
                              key: 0,
                              size: "small",
                              effect: "dark",
                              type: "info"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_23
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (item?.status == 'OPENING')
                          ? (_openBlock(), _createBlock(_component_Tag3, {
                              key: 1,
                              size: "small",
                              effect: "dark",
                              type: "success"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_24
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (item?.status == 'RESOLVED')
                          ? (_openBlock(), _createBlock(_component_Tag3, {
                              key: 2,
                              size: "small",
                              effect: "dark",
                              type: "warning"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_25
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _hoisted_26
                  ], 8, _hoisted_15))
                : _createCommentVNode("", true)
            ], 64))
          }), 256))
        ]))
      : _createCommentVNode("", true)
  ]))
}